"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ANIMATION_DURATION = 600;

var _StyledBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "YOffsetter___StyledBox",
  componentId: "qjoz8w-0"
})(["transition-property:transform;transition-duration:", "s;transform:translateY(", "px);"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var YOffsetter = function YOffsetter(_ref) {
  var yOffset = _ref.yOffset,
      props = _objectWithoutProperties(_ref, ["yOffset"]);

  return _react["default"].createElement(_StyledBox, _extends({}, props, {
    _css: ANIMATION_DURATION / 1000,
    _css2: yOffset
  }));
};

YOffsetter.propTypes = {
  yOffset: _propTypes.number.isRequired
};
var _default = YOffsetter;
exports["default"] = _default;